import { render, staticRenderFns } from "./GiftStores.vue?vue&type=template&id=54387fb2"
import script from "./GiftStores.vue?vue&type=script&lang=js"
export * from "./GiftStores.vue?vue&type=script&lang=js"
import style0 from "./GiftStores.vue?vue&type=style&index=0&id=54387fb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports